<div *ngIf="bolocrs$ | async as bolocrs">
  <div class="p-1 text-lg font-semibold">
    <span class="pl-1"
      >Page {{ page + 1 }}, Items {{ page * numPerPage + 1 }} - {{ page * numPerPage + bolocrs.length }}</span
    >
    <span class="mx-2"
      ><button mat-button class="mx-2 px-2 bg-blue-500 text-white" (click)="prevPage()">Prev. Page</button></span
    >
    <span class="mx-2"
      ><button mat-button class="mx-2 px-2 bg-blue-500 text-white" (click)="nextPage()">Next Page</button></span
    >
  </div>
  <div class="grid grid-cols-6 bg-blue-300 py-2 px-2">
    <div class="font-semibold">OrderID</div>
    <div class="font-semibold">BOL #</div>
    <div class="font-semibold">OCR Time</div>
    <div class="font-semibold">OCR Result</div>
    <div class="font-semibold">Audit Passed?</div>
    <div class="font-semibold">Notes</div>
  </div>
  <a
    *ngFor="let bolocr of bolocrs; trackBy: bolocrs | trackByKey2: 'ocrId'"
    [routerLink]="['../../', 'order', bolocr.orderId]"
    class="grid grid-cols-6 py-1 px-2 border-b border-gray-700"
  >
    <div>
      {{ bolocr.orderId }}
    </div>
    <div>
      {{ bolocr.bolNumber }}
    </div>
    <div>
      {{ bolocr.createdTimestamp | standardDate }}
    </div>
    <div>
      <div>{{ bolocr.auditRequestedBy }}</div>
      <div>{{ bolocr.auditRequestedTimestamp | standardDate }}</div>
    </div>
    <div>
      <div>{{ bolocr.auditPassed }}</div>
      <div>{{ bolocr.auditCompletedBy }}</div>
      <div>{{ bolocr.auditCompletedTimestamp | standardDate }}</div>
    </div>
    <div>
      {{ bolocr.notesInternal }}
    </div>
  </a>
</div>
